export default {
  password: /^(?=.*[!@#£\$%\^&\*])/,
};
